import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from '../../environments/environment';
import { UtilityService } from '../services/utility.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

export const loginGuard: CanActivateFn = () => {
  const utilService = inject(UtilityService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)) {
    if (utilService?.isUserLoggedIn()) {
      let webRedirectUrl = localStorage.getItem('web-redirect-url');
      if (!webRedirectUrl) {
        webRedirectUrl = 'dashboard';
      }
      const finalUrl = `${environment.webUrl}${environment.webBaseHref}${webRedirectUrl}`;

      utilService.openExternalPage(finalUrl);
      return false;
    }
  }

  return true;
};
